module.exports = {
      id: "bookmark-outline-usage",
      viewBox: "0 0 24 36",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#bookmark-outline",
      toString: function () {
        return this.url;
      }
    }